var dlsGray05 = {
  "color": "#53565a !important",
  "fill": "#53565a !important"
};

export { dlsGray05 };
